// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ——— Appointments index (Stitch Clinical Precision) ——— */
.appointments-screen {
  box-sizing: border-box;
  padding: 24px;
  min-width: 0;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.appointments-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  padding-bottom: 20px;
  border-bottom: 1px solid #E2E8F0;
}

.appointments-heading__left {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.appointments-heading__actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

.appointments-title-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.appointments-title-row h1 {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.02em;
  color: #0F172A;
}

.appointments-count {
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: 9999px;
  font-size: 12px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  background: #E0F2FE;
  color: #0284C7;
}

.appointments-subtitle {
  margin: 0;
  font-size: 13px;
  line-height: 18px;
  color: #64748B;
}

.appointments-btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 36px;
  padding: 0 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}

.appointments-btn--secondary {
  border: 1px solid #CBD5E1;
  background: #ffffff;
  color: #334155;
}

.appointments-btn--secondary:hover {
  background: #F8FAFC;
}

.appointments-btn--secondary .anticon {
  color: #64748B;
  font-size: 14px;
}

.appointments-btn--primary {
  border: 1px solid #0EA5E9;
  background: #0EA5E9;
  color: #ffffff;
}

.appointments-btn--primary:hover {
  background: #0284C7;
  border-color: #0284C7;
}

.appointments-btn--primary .anticon {
  font-size: 14px;
}

.appointments-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  pointer-events: none;
}

.appointments-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.appointments-search {
  position: relative;
  flex: 1 1 280px;
  min-width: 0;
  max-width: 100%;
}

.appointments-search__icon {
  position: absolute;
  inset-inline-start: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #94A3B8;
  font-size: 14px;
  pointer-events: none;
  z-index: 1;
}

.appointments-search__input.ant-input-affix-wrapper,
.appointments-search__input.ant-input {
  width: 100%;
  height: 36px;
  padding-inline-start: 36px !important;
  padding-inline-end: 40px !important;
  border-radius: 8px !important;
  border-color: #CBD5E1 !important;
  background: #ffffff !important;
  font-size: 13px;
}

.appointments-search__input.ant-input-affix-wrapper:focus,
.appointments-search__input.ant-input-affix-wrapper-focused,
.appointments-search__input.ant-input:focus {
  border-color: #0EA5E9 !important;
  box-shadow: 0 0 0 2px rgba(14, 165, 233, 0.2) !important;
}

.appointments-search__filter {
  position: absolute;
  inset-inline-end: 8px;
  top: 50%;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #94A3B8;
  cursor: pointer;
}

.appointments-search__filter:hover {
  background: #F8FAFC;
  color: #475569;
}

.appointments-status-filter {
  width: 200px;
  flex-shrink: 0;
}

.appointments-status-filter .ant-select-selector {
  height: 36px !important;
  border-radius: 8px !important;
  border-color: #CBD5E1 !important;
  align-items: center !important;
}

.appointments-table-card {
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  overflow: hidden;
  min-width: 0;
  max-width: 100%;
}

.appointments-list {
  height: auto;
  min-height: 120px;
  min-width: 0;
}

.appointments-table-scroll {
  width: 100%;
  overflow-x: auto;
  min-width: 0;
}

.appointments-table {
  --appt-cols: 88px minmax(160px, 1.3fr) minmax(120px, 1fr) minmax(110px, 0.9fr) minmax(120px, 1fr) 110px 120px 88px;
  display: grid;
  grid-template-columns: var(--appt-cols);
  width: 100%;
  min-width: 980px;
  font-size: 13px;
  background: #ffffff;
}

.appointments-table.is-fetching {
  opacity: 0.72;
}

.appointments-table__head,
.appointments-table__row {
  display: grid;
  grid-template-columns: subgrid;
  grid-column: 1 / -1;
  align-items: stretch;
  margin: 0;
  padding: 0;
  border-radius: 0;
  box-sizing: border-box;
}

.appointments-table__head {
  border-bottom: 1px solid #E2E8F0;
}

.appointments-table__head .appointments-cell {
  display: flex;
  align-items: center;
  min-height: 36px;
  padding: 8px 16px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #64748B;
  white-space: nowrap;
  background: #F8FAFC !important;
  border: 0 !important;
  border-radius: 0 !important;
}

.appointments-table__row {
  cursor: pointer;
  border-bottom: 1px solid #E2E8F0;
}

.appointments-table__row:last-child {
  border-bottom: 0;
}

.appointments-table__row .appointments-cell {
  display: flex;
  align-items: center;
  min-height: 40px;
  padding: 8px 16px;
  color: #0F172A;
  min-width: 0;
  background: #ffffff !important;
  border: 0 !important;
  border-radius: 0 !important;
  transition: background 0.12s ease;
}

.appointments-table__row:hover .appointments-cell {
  background: #F0F9FF !important;
}

.appointments-cell.is-action {
  justify-content: flex-end;
  text-align: end;
}

[dir='rtl'] .appointments-cell.is-action {
  justify-content: flex-start;
}

.appointments-id {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
  color: #64748B;
}

.appointments-patient {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}

.appointments-patient__name {
  font-size: 13px;
  font-weight: 700;
  line-height: 1.25;
  color: #0F172A;
}

.appointments-patient__phone {
  font-size: 11px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-variant-numeric: tabular-nums;
  color: #64748B;
  line-height: 1.25;
}

.appointments-chip {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  box-sizing: border-box;
  height: 24px;
  padding: 0 10px;
  border-radius: 6px;
  border: 1px solid #E2E8F0;
  background: #F1F5F9;
  color: #475569;
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.appointments-slot {
  display: flex;
  flex-direction: column;
  gap: 1px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-variant-numeric: tabular-nums;
  font-size: 12px;
}

.appointments-slot__date {
  font-weight: 500;
  color: #0F172A;
  line-height: 1.25;
}

.appointments-slot__time {
  font-size: 11px;
  color: #64748B;
  line-height: 1.25;
}

.appointments-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 22px;
  padding: 0 10px;
  border-radius: 9999px;
  font-size: 11px;
  font-weight: 500;
  border: 1px solid transparent;
  white-space: nowrap;
}

.appointments-status__dot {
  width: 6px;
  height: 6px;
  border-radius: 9999px;
  background: currentColor;
  flex-shrink: 0;
}

.appointments-status.is-waiting {
  background: #FFFBEB;
  color: #B45309;
  border-color: #FDE68A;
}

.appointments-status.is-waiting .appointments-status__dot {
  background: #F59E0B;
}

.appointments-status.is-confirmed {
  background: #ECFDF5;
  color: #047857;
  border-color: #A7F3D0;
}

.appointments-status.is-confirmed .appointments-status__dot {
  background: #10B981;
}

.appointments-status.is-invisit {
  background: #E0F2FE;
  color: #0369A1;
  border-color: #BAE6FD;
}

.appointments-status.is-invisit .appointments-status__dot {
  background: #0EA5E9;
}

.appointments-status.is-finished,
.appointments-status.is-pending,
.appointments-status.is-unreached,
.appointments-status.is-afterwork,
.appointments-status.is-postponed {
  background: #F1F5F9;
  color: #475569;
  border-color: #CBD5E1;
}

.appointments-status.is-finished .appointments-status__dot,
.appointments-status.is-pending .appointments-status__dot,
.appointments-status.is-unreached .appointments-status__dot,
.appointments-status.is-afterwork .appointments-status__dot,
.appointments-status.is-postponed .appointments-status__dot {
  background: #64748B;
}

.appointments-status.is-cancelled {
  background: #FEF2F2;
  color: #B91C1C;
  border-color: #FECACA;
}

.appointments-status.is-cancelled .appointments-status__dot {
  background: #EF4444;
}

.appointments-row-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #0EA5E9;
  font-size: 13px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
}

.appointments-row-link:hover {
  color: #0284C7;
}

[dir='rtl'] .appointments-row-link .anticon {
  transform: scaleX(-1);
}

.appointments-empty {
  padding: 40px 24px;
  text-align: center;
  color: #94A3B8;
}

.appointments-empty p {
  margin: 8px 0 0;
  font-size: 14px;
  font-weight: 500;
}

.appointments-pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 12px 16px;
  border-top: 1px solid #E2E8F0;
  background: #ffffff;
  font-size: 13px;
}

.appointments-pager__meta {
  color: #64748B;
  font-variant-numeric: tabular-nums;
}

.appointments-pager__controls {
  display: flex;
  align-items: center;
  gap: 8px;
}

.appointments-pager__btn {
  box-sizing: border-box;
  height: 32px;
  padding: 0 12px;
  border-radius: 6px;
  border: 1px solid #CBD5E1;
  background: #ffffff;
  color: #334155;
  font-size: 13px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
}

.appointments-pager__btn:hover:not(:disabled) {
  background: #F8FAFC;
}

.appointments-pager__btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.appointments-pager__page {
  font-variant-numeric: tabular-nums;
  color: #475569;
  font-size: 13px;
  font-weight: 500;
  min-width: 72px;
  text-align: center;
}

@media (max-width: 900px) {
  .appointments-status-filter {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Appointments/style.css"],"names":[],"mappings":"AAAA,2DAA2D;AAC3D;EACE,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,4EAA4E;AAC9E;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,UAAU;AACZ;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,mCAAmC;EACnC,6BAA6B;EAC7B,gCAAgC;EAChC,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;;;EAGE,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kHAAkH;EAClH,aAAa;EACb,uCAAuC;EACvC,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,8BAA8B;EAC9B,oBAAoB;EACpB,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6EAA6E;EAC7E,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,6EAA6E;EAC7E,kCAAkC;EAClC,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,6EAA6E;EAC7E,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;;EAKE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;;;;;EAKE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE;IACE,WAAW;EACb;AACF","sourcesContent":["/* ——— Appointments index (Stitch Clinical Precision) ——— */\n.appointments-screen {\n  box-sizing: border-box;\n  padding: 24px;\n  min-width: 0;\n  max-width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.appointments-heading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  padding-bottom: 20px;\n  border-bottom: 1px solid #E2E8F0;\n}\n\n.appointments-heading__left {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n}\n\n.appointments-heading__actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-shrink: 0;\n}\n\n.appointments-title-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.appointments-title-row h1 {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 1.2;\n  letter-spacing: -0.02em;\n  color: #0F172A;\n}\n\n.appointments-count {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 10px;\n  border-radius: 9999px;\n  font-size: 12px;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n  background: #E0F2FE;\n  color: #0284C7;\n}\n\n.appointments-subtitle {\n  margin: 0;\n  font-size: 13px;\n  line-height: 18px;\n  color: #64748B;\n}\n\n.appointments-btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 36px;\n  padding: 0 14px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n}\n\n.appointments-btn--secondary {\n  border: 1px solid #CBD5E1;\n  background: #ffffff;\n  color: #334155;\n}\n\n.appointments-btn--secondary:hover {\n  background: #F8FAFC;\n}\n\n.appointments-btn--secondary .anticon {\n  color: #64748B;\n  font-size: 14px;\n}\n\n.appointments-btn--primary {\n  border: 1px solid #0EA5E9;\n  background: #0EA5E9;\n  color: #ffffff;\n}\n\n.appointments-btn--primary:hover {\n  background: #0284C7;\n  border-color: #0284C7;\n}\n\n.appointments-btn--primary .anticon {\n  font-size: 14px;\n}\n\n.appointments-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\n.appointments-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.appointments-search {\n  position: relative;\n  flex: 1 1 280px;\n  min-width: 0;\n  max-width: 100%;\n}\n\n.appointments-search__icon {\n  position: absolute;\n  inset-inline-start: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #94A3B8;\n  font-size: 14px;\n  pointer-events: none;\n  z-index: 1;\n}\n\n.appointments-search__input.ant-input-affix-wrapper,\n.appointments-search__input.ant-input {\n  width: 100%;\n  height: 36px;\n  padding-inline-start: 36px !important;\n  padding-inline-end: 40px !important;\n  border-radius: 8px !important;\n  border-color: #CBD5E1 !important;\n  background: #ffffff !important;\n  font-size: 13px;\n}\n\n.appointments-search__input.ant-input-affix-wrapper:focus,\n.appointments-search__input.ant-input-affix-wrapper-focused,\n.appointments-search__input.ant-input:focus {\n  border-color: #0EA5E9 !important;\n  box-shadow: 0 0 0 2px rgba(14, 165, 233, 0.2) !important;\n}\n\n.appointments-search__filter {\n  position: absolute;\n  inset-inline-end: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  padding: 0;\n  border: 0;\n  border-radius: 6px;\n  background: transparent;\n  color: #94A3B8;\n  cursor: pointer;\n}\n\n.appointments-search__filter:hover {\n  background: #F8FAFC;\n  color: #475569;\n}\n\n.appointments-status-filter {\n  width: 200px;\n  flex-shrink: 0;\n}\n\n.appointments-status-filter .ant-select-selector {\n  height: 36px !important;\n  border-radius: 8px !important;\n  border-color: #CBD5E1 !important;\n  align-items: center !important;\n}\n\n.appointments-table-card {\n  box-sizing: border-box;\n  background: #ffffff;\n  border: 1px solid #E2E8F0;\n  border-radius: 8px;\n  overflow: hidden;\n  min-width: 0;\n  max-width: 100%;\n}\n\n.appointments-list {\n  height: auto;\n  min-height: 120px;\n  min-width: 0;\n}\n\n.appointments-table-scroll {\n  width: 100%;\n  overflow-x: auto;\n  min-width: 0;\n}\n\n.appointments-table {\n  --appt-cols: 88px minmax(160px, 1.3fr) minmax(120px, 1fr) minmax(110px, 0.9fr) minmax(120px, 1fr) 110px 120px 88px;\n  display: grid;\n  grid-template-columns: var(--appt-cols);\n  width: 100%;\n  min-width: 980px;\n  font-size: 13px;\n  background: #ffffff;\n}\n\n.appointments-table.is-fetching {\n  opacity: 0.72;\n}\n\n.appointments-table__head,\n.appointments-table__row {\n  display: grid;\n  grid-template-columns: subgrid;\n  grid-column: 1 / -1;\n  align-items: stretch;\n  margin: 0;\n  padding: 0;\n  border-radius: 0;\n  box-sizing: border-box;\n}\n\n.appointments-table__head {\n  border-bottom: 1px solid #E2E8F0;\n}\n\n.appointments-table__head .appointments-cell {\n  display: flex;\n  align-items: center;\n  min-height: 36px;\n  padding: 8px 16px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #64748B;\n  white-space: nowrap;\n  background: #F8FAFC !important;\n  border: 0 !important;\n  border-radius: 0 !important;\n}\n\n.appointments-table__row {\n  cursor: pointer;\n  border-bottom: 1px solid #E2E8F0;\n}\n\n.appointments-table__row:last-child {\n  border-bottom: 0;\n}\n\n.appointments-table__row .appointments-cell {\n  display: flex;\n  align-items: center;\n  min-height: 40px;\n  padding: 8px 16px;\n  color: #0F172A;\n  min-width: 0;\n  background: #ffffff !important;\n  border: 0 !important;\n  border-radius: 0 !important;\n  transition: background 0.12s ease;\n}\n\n.appointments-table__row:hover .appointments-cell {\n  background: #F0F9FF !important;\n}\n\n.appointments-cell.is-action {\n  justify-content: flex-end;\n  text-align: end;\n}\n\n[dir='rtl'] .appointments-cell.is-action {\n  justify-content: flex-start;\n}\n\n.appointments-id {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 12px;\n  font-weight: 500;\n  font-variant-numeric: tabular-nums;\n  color: #64748B;\n}\n\n.appointments-patient {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  min-width: 0;\n}\n\n.appointments-patient__name {\n  font-size: 13px;\n  font-weight: 700;\n  line-height: 1.25;\n  color: #0F172A;\n}\n\n.appointments-patient__phone {\n  font-size: 11px;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-variant-numeric: tabular-nums;\n  color: #64748B;\n  line-height: 1.25;\n}\n\n.appointments-chip {\n  display: inline-flex;\n  align-items: center;\n  max-width: 100%;\n  box-sizing: border-box;\n  height: 24px;\n  padding: 0 10px;\n  border-radius: 6px;\n  border: 1px solid #E2E8F0;\n  background: #F1F5F9;\n  color: #475569;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.appointments-slot {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-variant-numeric: tabular-nums;\n  font-size: 12px;\n}\n\n.appointments-slot__date {\n  font-weight: 500;\n  color: #0F172A;\n  line-height: 1.25;\n}\n\n.appointments-slot__time {\n  font-size: 11px;\n  color: #64748B;\n  line-height: 1.25;\n}\n\n.appointments-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 22px;\n  padding: 0 10px;\n  border-radius: 9999px;\n  font-size: 11px;\n  font-weight: 500;\n  border: 1px solid transparent;\n  white-space: nowrap;\n}\n\n.appointments-status__dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 9999px;\n  background: currentColor;\n  flex-shrink: 0;\n}\n\n.appointments-status.is-waiting {\n  background: #FFFBEB;\n  color: #B45309;\n  border-color: #FDE68A;\n}\n\n.appointments-status.is-waiting .appointments-status__dot {\n  background: #F59E0B;\n}\n\n.appointments-status.is-confirmed {\n  background: #ECFDF5;\n  color: #047857;\n  border-color: #A7F3D0;\n}\n\n.appointments-status.is-confirmed .appointments-status__dot {\n  background: #10B981;\n}\n\n.appointments-status.is-invisit {\n  background: #E0F2FE;\n  color: #0369A1;\n  border-color: #BAE6FD;\n}\n\n.appointments-status.is-invisit .appointments-status__dot {\n  background: #0EA5E9;\n}\n\n.appointments-status.is-finished,\n.appointments-status.is-pending,\n.appointments-status.is-unreached,\n.appointments-status.is-afterwork,\n.appointments-status.is-postponed {\n  background: #F1F5F9;\n  color: #475569;\n  border-color: #CBD5E1;\n}\n\n.appointments-status.is-finished .appointments-status__dot,\n.appointments-status.is-pending .appointments-status__dot,\n.appointments-status.is-unreached .appointments-status__dot,\n.appointments-status.is-afterwork .appointments-status__dot,\n.appointments-status.is-postponed .appointments-status__dot {\n  background: #64748B;\n}\n\n.appointments-status.is-cancelled {\n  background: #FEF2F2;\n  color: #B91C1C;\n  border-color: #FECACA;\n}\n\n.appointments-status.is-cancelled .appointments-status__dot {\n  background: #EF4444;\n}\n\n.appointments-row-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: #0EA5E9;\n  font-size: 13px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.appointments-row-link:hover {\n  color: #0284C7;\n}\n\n[dir='rtl'] .appointments-row-link .anticon {\n  transform: scaleX(-1);\n}\n\n.appointments-empty {\n  padding: 40px 24px;\n  text-align: center;\n  color: #94A3B8;\n}\n\n.appointments-empty p {\n  margin: 8px 0 0;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.appointments-pager {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n  padding: 12px 16px;\n  border-top: 1px solid #E2E8F0;\n  background: #ffffff;\n  font-size: 13px;\n}\n\n.appointments-pager__meta {\n  color: #64748B;\n  font-variant-numeric: tabular-nums;\n}\n\n.appointments-pager__controls {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.appointments-pager__btn {\n  box-sizing: border-box;\n  height: 32px;\n  padding: 0 12px;\n  border-radius: 6px;\n  border: 1px solid #CBD5E1;\n  background: #ffffff;\n  color: #334155;\n  font-size: 13px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n}\n\n.appointments-pager__btn:hover:not(:disabled) {\n  background: #F8FAFC;\n}\n\n.appointments-pager__btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.appointments-pager__page {\n  font-variant-numeric: tabular-nums;\n  color: #475569;\n  font-size: 13px;\n  font-weight: 500;\n  min-width: 72px;\n  text-align: center;\n}\n\n@media (max-width: 900px) {\n  .appointments-status-filter {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
